import tyreStack from "../images/tyres.png"
import '../App.css';

function AboutOne() {
    return (
<div className="hero justify-start bg-white text-white font-general italic">
        <div className="flex flex-row items-center">
        <div className="hidden md:flex md:flex-col md:p-20 md:justify-center items-center md:font-bold md:w-1/4">
            <img
            src={tyreStack}
            width={200}
            className="max-w-sm pl-10" 
            alt="tyre stack"
            />
          </div>
          <div className="flex flex-col gap-10 ml-10 p-20 font-bold w-full md:w-3/4">
          <p className="text-xl text-zinc-800 text-center md:text-left">
          Rescue Tyres LTD is dedicated to providing top-quality, professional services at competitive rates for both private and commercial clients. We offer a range of services including premium tyres, new tyres, part-worn tyres, locking wheel nut removal, and puncture repair.
          </p>
          </div>
          
        </div>
      </div>
  );
}

export default AboutOne;
